export default __webpack_public_path__ + "static/media/grafema_design-factory-kitchen-pictograms_01.6beb9a0d.jpg";